import { AccessCodeStatus, SubscriptionDurationValue, SubscriptionPlanValue } from '../../types/accessCode';

export const FILTER_STATUS = [
  {
    text: AccessCodeStatus.ALL,
    value: AccessCodeStatus.ALL,
  },
  {
    text: AccessCodeStatus.AVAILABLE,
    value: AccessCodeStatus.AVAILABLE,
  },
  {
    text: AccessCodeStatus.ACTIVE,
    value: AccessCodeStatus.ACTIVE,
  },
  {
    text: AccessCodeStatus.INACTIVE_BY_UPGRADE,
    value: AccessCodeStatus.INACTIVE_BY_UPGRADE,
  },
  {
    text: AccessCodeStatus.INACTIVE,
    value: AccessCodeStatus.INACTIVE,
  },
  {
    text: AccessCodeStatus.EXPIRED,
    value: AccessCodeStatus.EXPIRED,
  },
];

export const FILTER_PLAN = [
  {
    text: 'All',
    value: SubscriptionPlanValue.ALL,
  },
  {
    text: 'Champion',
    value: SubscriptionPlanValue.CHAMPION,
  },
  {
    text: 'Legend',
    value: SubscriptionPlanValue.LEGEND,
  },
];

export const FILTER_DURATION = [
  {
    text: 'All',
    value: SubscriptionDurationValue.ALL,
  },
  {
    text: 'Monthly',
    value: SubscriptionDurationValue.MONTHLY,
  },
  {
    text: 'Yearly',
    value: SubscriptionDurationValue.YEARLY,
  },
];
